import { rewardsAuthApiClientToken } from "@apps/rewards/tokens";
import { JsonMimeType } from "@lib/ApiClient";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { inject, singleton } from "tsyringe";

@singleton()
class RewardsVerificationTokenApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    sendVerificationToken(): Observable<unknown> {
        return this.apiClient.post({
            url: "/points/sendVerificationToken",
            responseType: "text",
            contentType: JsonMimeType,
        });
    }
}

export default RewardsVerificationTokenApiService;
